<poker-core-lazy-placeholder
    *ngIf="!isSelectionView"
    [inputData]="{ item: item }"
    [componentName]="'PPBlogFeedLWComponent'"></poker-core-lazy-placeholder>

<pp-blog-selection-wrapper *ngIf="isSelectionView" [info]="item"></pp-blog-selection-wrapper>
